import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="页面不存在"
      subTitle="该地址可能已变更，或相关模块尚未进入当前交付阶段。"
      extra={
        <Button type="primary" onClick={() => navigate("/workspace")}>
          返回工作台
        </Button>
      }
    />
  );
}
